import { format, formatDistanceToNowStrict, isToday, isTomorrow } from 'date-fns';
import { bg } from 'date-fns/locale';
import type { Currency } from '@kmdx/contracts';

/** Часовете се пишат 24-часово — шофьорът чете „14:30", не „2:30 PM". */

export function timeOf(iso: string | null | undefined): string {
  if (!iso) return '—';
  return format(new Date(iso), 'HH:mm');
}

export function dayOf(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (isToday(date)) return 'днес';
  if (isTomorrow(date)) return 'утре';
  return format(date, 'd MMMM', { locale: bg });
}

export function dayTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return `${dayOf(iso)}, ${timeOf(iso)}`;
}

export function fullDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return format(new Date(iso), 'd MMMM yyyy, HH:mm', { locale: bg });
}

export function relative(iso: string | number | null | undefined): string {
  if (iso === null || iso === undefined) return '—';
  return formatDistanceToNowStrict(new Date(iso), { addSuffix: true, locale: bg });
}

export function money(minor: number, ccy: Currency | string): string {
  try {
    return new Intl.NumberFormat('bg-BG', {
      style: 'currency',
      currency: ccy,
      minimumFractionDigits: 2,
    }).format(minor / 100);
  } catch {
    return `${(minor / 100).toFixed(2)} ${ccy}`;
  }
}

export function bytes(size: number): string {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${Math.round(size / 1024)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

/** Телефон за набиране: маха интервалите, пази водещия плюс. */
export function telHref(phone: string | null | undefined): string | null {
  if (!phone) return null;
  const cleaned = phone.replace(/[^\d+]/g, '');
  return cleaned.length >= 5 ? `tel:${cleaned}` : null;
}
